import { z } from 'zod';
import { CalendarItem, CalendarQuery, CalendlyLinkInput } from '../../calendar.js';
export const calendarRoutes = {
    mine: {
        method: 'GET',
        path: '/me/calendar',
        query: CalendarQuery,
        response: z.array(CalendarItem),
    },
    setCalendly: {
        method: 'PUT',
        path: '/me/calendly',
        body: CalendlyLinkInput,
        response: z.object({ url: z.string() }),
    },
    getCalendly: {
        method: 'GET',
        path: '/users/:userId/calendly',
        response: z.object({ url: z.string().nullable() }),
    },
};
//# sourceMappingURL=routes.js.map